import React, { useEffect } from 'react';
import CustomPagination from 'src/components/CustomPagination/CustomPagination';
import { useClientPagination } from 'src/components/CustomPagination/useClientPagination';
import { StagedEntry } from 'src/components/ContactsTable/EmailSelfServiceDialogue/CustomHooks/useEmailSelfServiceFormState/useEmailSelfServiceFormState';
import EntryRow, {
  SectionVariant,
} from 'src/components/ContactsTable/EmailSelfServiceDialogue/StepConfirmation/EntryRow/EntryRow';
import './section.scss';

const SECTION_ITEMS_PER_PAGE: number = 10;

export interface SectionProps {
  variant: SectionVariant;
  heading: string;
  entries: StagedEntry[];
}

const Section = ({ variant, heading, entries }: SectionProps) => {
  const count: number = entries.length;

  const {
    currentPage,
    totalPages,
    paginatedItems,
    setCurrentPage,
    resetToFirstPage,
  } = useClientPagination<StagedEntry>({
    items: entries,
    itemsPerPage: SECTION_ITEMS_PER_PAGE,
  });

  useEffect(() => {
    resetToFirstPage();
  }, [count]);

  if (count === 0) {
    return null;
  }

  const sectionClassName: string = `sc-section sc-section-${variant}`;
  const showPagination: boolean = totalPages > 1;

  return (
    <div className={sectionClassName}>
      <div className="sc-section-header">
        <span className="sc-section-heading">{heading}</span>
        <span className="sc-section-count">{count}</span>
      </div>
      <div className="sc-section-list">
        {paginatedItems.map((entry: StagedEntry) => (
          <EntryRow
            key={entry.contact.id}
            entry={entry}
            variant={variant}
          />
        ))}
      </div>
      {showPagination && (
        <div className="sc-section-pagination">
          <CustomPagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
          />
        </div>
      )}
    </div>
  );
};

export default Section;
